import React, { useState } from "react";
import {
  Col,
  Row,
  Avatar,
  Tooltip,
  Button,
  Space,
  Card,
  Divider,
  Form,
  Input,
  Menu,
  Dropdown,
  Alert,
} from "antd";
import "./index.css";
import { NavLink, useParams, useLocation } from "react-router-dom";

const cardList = [
  {
    itemType: "A. Move Out",
    icon: "fa-solid fa-truck",
    items: [
      { title: "Evaluate move out", status: false },
      { title: "Make Ready", status: false },
      { title: "Property Listing", status: false },
      { title: "Confirm notice", status: false },
      { title: "Single Move Out ", status: false },
      { title: "Breaking Lease", status: false },
      { title: "Move out Directions", status: false },
      { title: "Owner Requested non renewal", status: false },
      { title: "Keys In SD Refund!!", status: false },
    ],
  },
  {
    itemType: "B. Make Ready",
    items: [
      { title: "Evaluate status of property", status: false },
      { title: "Send owner Make Ready Email", status: false },
      { title: "Stingray Make Ready", status: false },
      { title: "MAKE READY FUNDS-IMPORTANT", status: false },
      { title: "Owner Doing Make Ready ", status: false },
      { title: "Utility Activation", status: false },
      { title: "Lawn Care Start", status: false },
      { title: "Owner Requested non renewal", status: false },
      { title: "Keys In SD Refund!!", status: false },
    ],
  },
];

const Viewing = () => {
  const { category } = useParams();
  const [clickedIndex, setClickedIndex] = useState(-1);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let item = queryParams.get("item");
  let item1 = item;
  const moveOutItem = cardList.find((item) => item.itemType === category);
  const moveOutTitles = moveOutItem.items.map((item) => item.title);
  const moveOutItem1 = cardList.find((item) => item.itemType === category);

  const menu = (
    <Menu
      style={{ width: "200px", height: "300px", overflow: "scroll" }}
      aria-label="Options"
    >
      <Menu.Item key="1">
        <i className="fa-solid fa-table-list"></i> View Workflow runs
      </Menu.Item>
      <Menu.Item key="2">
        <i className="fa-solid fa-link"></i> Copy Share Link
      </Menu.Item>
      <Menu.Item key="3">
        <p>
          <i className="fa-solid fa-play"></i> Workflow run link
        </p>
      </Menu.Item>
      <Menu.Item key="4">
        <p>
          <i className="fa-solid fa-forward"></i> Run multiple
        </p>
      </Menu.Item>
      <Menu.Item key="5">
        <p>
          <i className="fa-regular fa-clock"></i> Scheduled workFlow
        </p>
      </Menu.Item>
      <Menu.Item key="6">
        <p>
          <i className="fa-solid fa-clock-rotate-left"></i> Activity
        </p>
      </Menu.Item>
      <Menu.Item key="7">
        <p>
          <i className="fa-regular fa-eye"></i> Subscribe
        </p>
      </Menu.Item>
      <Menu.Item key="8">
        <p>
          <i className="fa-solid fa-tag"></i> Manage tags
        </p>
      </Menu.Item>

      <Menu.Item key="9">
        <p>
          <i className="fa-solid fa-share"></i> Add to public library
        </p>
      </Menu.Item>
      <Menu.Item key="10">
        <p>
          <i className="fa-solid fa-arrow-right"></i> Move
        </p>
      </Menu.Item>
      <Menu.Item key="11">
        <p>
          <i className="fa-solid fa-copy"></i> Duplicate
        </p>
      </Menu.Item>
      <Menu.Item key="12">
        <p>
          <i className="fa-solid fa-download"></i> Export
        </p>
      </Menu.Item>
      <Menu.Item key="13">
        <p>
          <i className="fa-solid fa-print"></i> Print
        </p>
      </Menu.Item>
      <Menu.Item key="14">
        <p>
          <i className="fa-solid fa-box-archive"></i> Archive
        </p>
      </Menu.Item>
      <Menu.Item key="15">
        <p style={{ color: "red" }}>
          <i className="fa-regular fa-trash-can"></i> Delete
        </p>
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      <Row style={{ marginBottom: "20px" }}>
        <Col span={12}>
          <p>
            <Space>
              <strong> Viewing</strong>
              <i className="fa-solid fa-diagram-project"></i>
              <span>{category}</span>
            </Space>
          </p>
          <p style={{ color: "#b2b5b7" }}>
            Library / A. Property Management Process
          </p>
        </Col>
        <Col span={12}>
          <div>
            <Space>
              <i className="fa-solid fa-mobile-retro"></i>
              <Avatar.Group
                maxCount={2}
                maxStyle={{
                  color: "#f56a00",
                  backgroundColor: "#fde3cf",
                }}
              >
                <Tooltip title="Amir Ali" placement="top">
                  <Avatar>A</Avatar>
                </Tooltip>
                <Tooltip title="Afaque Ahmed" placement="top">
                  <Avatar>A</Avatar>
                </Tooltip>
                <Tooltip title="Afaque Ahmed" placement="top">
                  <Avatar>A</Avatar>
                </Tooltip>
              </Avatar.Group>
              Share
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button>
                  <i className="fa-solid fa-ellipsis"></i>
                </Button>
              </Dropdown>
              <Button>Edit</Button>
              <Button>
                <i className="fa-solid fa-play"> </i> Run Workflow
              </Button>
            </Space>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <h3>
            <i className={`${moveOutItem.icon}`}> </i> {moveOutItem.itemType}
          </h3>
          <p style={{ marginBottom: "10px" }}>Tenant Move out process</p>
          <div style={{ overflow: "scroll", height: "82vh" }}>
            {moveOutTitles.map((card, index) => (
              <Row>
                <Col
                  span={1}
                  style={{ lineHeight: "40px", textAlign: "center" }}
                >
                  <i className={`fa-solid fa-${index + 1}`}></i>
                </Col>
                <Col span={23}>
                  <NavLink to={`?item=${card}`}>
                    <Card
                      size="small"
                      key={index}
                      className={clickedIndex === index ? "clicked" : ""}
                      onClick={() =>
                        setClickedIndex(index === clickedIndex ? -1 : index)
                      }
                    >
                      {card}
                    </Card>
                  </NavLink>
                </Col>
              </Row>
            ))}
          </div>
        </Col>
        {/* Evaluate Move Out */}
        {item == "Evaluate move out" ? (
          <Col span={12} style={{ padding: "10px" }}>
            <p>Evaluate move out</p>
            <Divider />
            <p>
              Verify Tenant move out date and ensure it has not been cancelled.
            </p>
            <Form layout="vertical" autoComplete="off">
              <Form.Item name="Event" label="Event">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
              <Form.Item name="Tenant" label="Tenant">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
              <Form.Item name="PropertyName" label="Property Name">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
              <Form.Item name="MoveOutDate" label="Move out Date">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
            </Form>
          </Col>
        ) : null}

        {item == "Make Ready" ? (
          <Col span={12} style={{ padding: "10px" }}>
            <p>Make Ready</p>
            <Divider />
            <h3 style={{ color: "#0079ca" }}>
              This task will start a make ready workflow when you select it and
              will assign it to you.
            </h3>
          </Col>
        ) : null}

        {item == "Property Listing" ? (
          <Col span={12} style={{ padding: "10px" }}>
            <p>Property Listing</p>
            <Divider />
            <h3 style={{ color: "#0079ca" }}>
              This task will create a property listing workflow and assign it to
              you
            </h3>
          </Col>
        ) : null}
        {item == "Evaluate status of property" ? (
          <Col span={12} style={{ padding: "10px" }}>
            <p>Evaluate status of property</p>
            <Divider />

            <Alert
              description="Make sure property is vacant or has a pending move out - view the property page and tenant page in appfolio to verify."
              type="info"
            />

            <Form layout="vertical" autoComplete="off">
              <Form.Item name="Tenant Name" label="Tenant Name">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
              <Form.Item name="Property Address" label="Property Address">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
              <Form.Item name="Moveoutdate" label="Move out date">
                <Input
                  placeholder="Short text will be typed here..."
                  disabled
                />
              </Form.Item>
              <Form.Item
                name="MoveOutDate"
                label="Users email - property manager"
              >
                <Input
                  placeholder="e.g., amirali@sayeagle"
                  addonBefore={<i className="fa-solid fa-envelope"></i>}
                />
              </Form.Item>
            </Form>
          </Col>
        ) : null}

        {item == "Send owner Make Ready Email" ? (
          <Col span={12} style={{ padding: "10px" }}>
            <p>Send owner Make Ready Email</p>
            <Divider />
            <Space direction="vertical">
              <Alert
                description="Copy and Paste this message to owner in appfolio (be sure to put property address in subject line)  This should be sent prior to the keys being turned in so we have time to evaluate who will handle the work order."
                type="warning"
              />

              <Alert
                description="Your tenant will be vacating the property above in the coming weeks.  "
                type="warning"
              />
              <Alert
                description="We have a great crew we use for make ready work or if you prefer to do the work yourself that is fine as well.  (Be aware if you plan to perform the work yourself or have a vendor of your choosing do the work we will need to complete an inspection prior to listing.  There is a fee of $150 for an inspection if you elect to do the work yourself.)  If you are going to use our preferred vendor we can get them in to get a bid as soon as the house is vacated.  "
                type="warning"
              />
              <Alert
                description="If you plan to do yourself we will notify you when we have the keys in a lockbox at the property.  "
                type="warning"
              />
              <Alert
                description="Be aware that if you do request a bid but elect to not use our preferred vendor there may be a service call fee for their estimate and inspection services. "
                type="warning"
              />
              <Alert
                description="Just let me know asap how you plan to proceed so we can get things set up on our end to avoid delays."
                type="warning"
              />
            </Space>
          </Col>
        ) : null}
      </Row>
    </>
  );
};
export default Viewing;
